// phonics_data_lt13.js
// Letter Teams L13 - L13 Long Vowel Sounds ew, ue
// 路由：/phonics/lt13

const MEDIA_BASE = '/media/phonics/lt13';
const V = 'v1';

export const letterDataLt13 = {
  id: 'lt13',
  letter: 'L13',
  title: 'L13 Long Vowel Sounds ew, ue',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1) → part1.mp4
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3) → part3.mp4
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）→ review.png
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P7/P8/P9: 三段故事（只有英文台词，无中文）
  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "The pals are mad.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "My new train!", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "My new hat!", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "My new bowl!", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "Who broke them?", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "They see Kate, Sue, and Glen.", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "Let's look for a clue!", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
        { en: "Green finds blue spots.", audioEn: `${MEDIA_BASE}/story1_8.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "Here is a clue.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "It was Sue!", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "What can I do?", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Here are some screws.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "I can fix Pink's new train!", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "Sue takes the screws.", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Here is some glue.", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "I can fix Yellow's new hat!", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "I can fix Green's new bowl!", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Good job, Sue!", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "Let's eat stew!", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "Yummy!", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
      ],
    },
  ],
};
